'use strict';

require('../../style/index.less');

require('./index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/input/style/index.js
 ** module id = 13
 ** module chunks = 0
 **/